<div class="cell-container" (click)="$event.stopPropagation(); activityName.focus()">
  <mat-form-field floatLabel="never" color="accent">
    <input #activityName matInput placeholder="Activity Name"
           [disabled]="readonly"
           [(ngModel)]="name"
           (change)="update()"
    >
  </mat-form-field>
</div>
